module.exports = __webpack_public_path__ + "d143f8a9a39d551525467d91b40f6d70.jpg";